import * as THREE from "three";

/**
 * A cinematic camera anchor
 */
export class CameraAnchor {
    /**
     * Construct a camera anchor
     */
    constructor() {
        this.position = new THREE.Vector3();
    }

    /**
     * Calculate the anchor position given a target position
     * @param {Vector3} target The target position
     * @param {number} distance The distance traveled along the track
     * @param {number} lap The lap length
     */
    calculatePosition(target, distance, lap) {

    }

    /**
     * Get the position of this anchor given a target position
     * @param {Vector3} target The target position
     * @param {number} distance The distance traveled along the track
     * @param {number} lap The lap length
     */
    getPosition(target, distance, lap) {
        this.calculatePosition(target, distance, lap);

        return this.position;
    }
}
